import { ReactComponent as YelpIcon } from "./yelp.svg";

import Icon from "../Icon";

export default YelpIcon as any as Icon;
